<template>
  <div>
    <a-card class="step-card">
      <div class="step-card-content">
        <a-steps :class="[4, 13].includes(templateId) ? 'step-card-steps-with-nodes' : 'step-card-steps'" size="small" :current="current" :style="{ width: `${steps.length * 202}px` }">
          <a-step v-for="step in steps" :key="step.id" :title="step.name">
            <a-timeline v-if="step.name !== '完成' && abstractDict[step.id] && step.id < currentStepId" slot="description" style="margin-top: 15px; margin-left: 2px; margin-bottom: -10px">
              <a-timeline-item v-for="(node, index) in abstractDict[step.id].nodes" :key="index">
                <a-tag slot="dot" color="cyan">{{ node.label }}</a-tag>
                <div v-if="['测试计划'].includes(node.label)" style="padding-left: 20px">
                  <span v-if="node.value === null || node.value.length == 0" style="padding-left: 5px"> -- </span>
                  <span v-for="(v, i) in node.value" :key="i">
                    <a class="issue_title" :href="planLink(v)" target="_blank">{{ v.name.length > 9 ? v.name.substring(0, 9) + '...' : v.name }}</a>
                    <br />
                  </span>
                </div>
                <div v-else-if="['自动化'].includes(node.label)" style="padding-left: 20px">
                  <span v-for="(v, i) in node.value" :key="i" style="padding-left: 5px">
                    <a-button v-if="v[1].length > 0" type="dashed" icon="eye" :style="{ 'margin-top': i >= 1 ? '2px' : '0px' }" size="small" @click="viewAutomation(v[1])">
                      <a v-if="v[0] === 'review'" style="color: gray">
                        {{ '回归测试详情' }}
                      </a>
                      <a v-if="v[0] === 'qa_verify'" style="color: gray">
                        {{ '质量验收详情' }}
                      </a>
                    </a-button>
                  </span>
                  <br />
                </div>
                <div v-else-if="['审批'].includes(node.label)" style="padding-left: 20px">
                  <span v-for="(v, i) in node.value" :key="i" style="padding-left: 5px">
                    <a-avatar :size="20" :src="v.avatar_url" /> <span class="nickname">{{ v.nickname }} </span>
                  </span>
                </div>
                <div v-else-if="['兼容性', '性能'].includes(node.label)" style="padding-left: 20px">
                  <span v-if="node.value === null || node.value.length == 0" style="padding-left: 5px"> -- </span>
                  <template v-else>
                    <span v-for="(v, i) in node.value" :key="i" style="padding-left: 5px">
                      <a-tooltip v-if="v.hover" overlay-class-name="bgcolor">
                        <template slot="title">
                          <vditor-preview :content="v.hover" />
                        </template>
                        <a-tag v-if="v.result === 1" color="#87d068">Pass</a-tag>
                        <a-tag v-else-if="v.result === 2" color="#f50">Fail</a-tag>
                      </a-tooltip>
                      <template v-else>
                        <a-tag v-if="v.result === 1" color="#87d068">Pass</a-tag>
                        <a-tag v-else-if="v.result === 2" color="#f50">Fail</a-tag>
                      </template>
                    </span>
                  </template>
                </div>
                <div v-else-if="['确认项'].includes(node.label)" style="padding-left: 25px">
                  <a-tooltip overlay-class-name="bgcolor">
                    <template slot="title">
                      <a-list size="small" :split="false" :data-source="confirmItems[step.id]">
                        <a-list-item slot="renderItem" slot-scope="item" style="display: block">
                          <a-icon type="check-square" style="color: green; font-size: 15px" /><span style="margin-left: 5px; font-weight: 500">{{ item.content }}</span>
                        </a-list-item>
                      </a-list>
                    </template>
                    <a-tag color="#87d068" style="cursor: pointer">详情</a-tag>
                  </a-tooltip>
                </div>
                <div v-else style="padding-left: 20px">
                  <span v-if="node.value === null"> -- </span>
                  <template v-else>
                    <span v-for="(v, i) in node.value" :key="i">{{ v }}</span>
                  </template>
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-step>
        </a-steps>
      </div>
    </a-card>
    <a-modal v-model="modalOpen" width="960px" title="自动化执行详情" :footer="false" @cancel="cancel">
      <a-table :data-source="tableData" :columns="columns">
        <span slot="task_name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.taskName">
            <a @click="lineAutomaiton(record.task_url)">{{ record.task_name }}</a>
          </a-tooltip>
        </span>
        <span slot="result" slot-scope="text, record">
          <a-tag v-if="record.result === 1" color="green">{{ '通过' }}</a-tag>
          <a-tag v-if="record.result === 2" color="red">{{ '失败' }}</a-tag>
          <a-tag v-if="record.result === null" color="gold">{{ '执行中' }}</a-tag>
        </span>
        <span slot="task_type" slot-scope="text, record">
          <a-tag v-if="record.task_type === 3" color="purple">{{ '女娲' }}</a-tag>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import VditorPreview from '@/components/VditorEditor/preview';
import { taskDeliveryConfirmItems, integratedConfirmItems } from '@/utils/dictionary';

export default {
  components: { VditorPreview },
  props: {
    current: {
      type: Number,
      default: 0
    },
    currentStepId: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => {
        return [];
      }
    },
    abstract: {
      type: Array,
      default: () => {
        return [];
      }
    },
    templateId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      integratedConfirmItems,
      taskDeliveryConfirmItems,
      modalOpen: false,
      tableData: [],
      columns: [
        {
          title: '任务id',
          dataIndex: 'task_id',
          key: 'task_id',
          scopedSlots: { customRender: 'task_id' }
        },
        {
          title: '任务名',
          dataIndex: 'task_name',
          key: 'task_name',
          scopedSlots: { customRender: 'task_name' }
        },
        {
          title: '执行结果',
          dataIndex: 'result',
          key: 'result',
          scopedSlots: { customRender: 'result' }
        },
        {
          title: '执行平台',
          dataIndex: 'task_type',
          key: 'task_type',
          scopedSlots: { customRender: 'task_type' }
        }
      ],
      abstractDict: {}
    };
  },
  computed: {
    confirmItems() {
      return stepId => {
        switch (stepId) {
          case 94:
            return this.taskDeliveryConfirmItems;
          case 146:
            return this.integratedConfirmItems;
          default:
            return [];
        }
      };
    },
    planLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        });
        return route.href;
      };
    }
  },
  watch: {
    abstract: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          val.forEach(item => {
            this.$set(this.abstractDict, item.step_id, item);
          });
        }
      }
    }
  },
  methods: {
    cancel() {
      this.modalOpen = false;
    },
    lineAutomaiton(url) {
      window.open(url);
    },
    viewAutomation(data) {
      this.modalOpen = true;
      this.tableData = data;
    }
  }
};
</script>
<style lang="less">
.step-card {
  .ant-card-body {
    padding: 18px 20px 0px 20px;
  }
}

.sub-node {
  margin-top: 5px;
  margin-left: -20px;

  .ant-list-item-no-flex {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}

.bgcolor .ant-tooltip-inner {
  color: #333 !important;
  background-color: #fff !important;
  width: 550px;
}
</style>
<style lang="less" scoped>
.step-card {
  .step-card-content {
    overflow: auto;
    padding: 10px 0;

    .step-card-steps {
      margin-bottom: 12px;
    }

    .step-card-steps-with-nodes {
      /deep/ .ant-steps-item-description {
        max-width: 188px !important;
      }

      /deep/ .ant-timeline-item-head-custom .ant-tag {
        width: 65px;
      }

      /deep/ .ant-timeline-item-tail {
        left: 0;
      }
    }
  }
}
</style>
